export default __webpack_public_path__ + "static/media/allianz.d5729bd6.svg";